import React from "react";
import { AnimatePresence } from "framer-motion";
import Card from "./Card";

export default function CardList({ cards, onHide }) {
	return (
		<div className="pn-stack__cards" data-testid="progress-stack-cards">
			<AnimatePresence initial={false}>
				{cards.map((card) => (
					<Card key={card.id} card={card} onHide={onHide} />
				))}
			</AnimatePresence>
		</div>
	);
}
